import { OEM_APP_ENUM, RENDER_TEMPLATE_ENUM } from "@/../config/config.js";

class Content {
    constructor({
        title,
        file,
        version,
        desc,
        // supportLang,
        renderTemplate,
        show
    }) {
        this.title = title; //在版本列表显示的信息
        this.file = file; //目录名称
        this.version = version; //目录名称，和/static/langPackzh对应
        this.desc = desc; //描述
        // this.supportLang = supportLang; //支持的语言
        this.renderTemplate = renderTemplate; //渲染的模板,模板的类型决定了数据源的扩展名
        this.show = show; //这里指定那些app（通过set OEM_APP="OMNIA_Smart"设置）可以显示这个版本
    }
}

//! 设置各个OEM APP支持的版本号
const list = [
    new Content({
        // num: 3,
        title: "20200000",
        file: "20200000",
        version: "v3",
        desc: "这个不知道是什么时候的版本",
        // supportLang: [
        //     "da",
        //     "de",
        //     "en",
        //     "es",
        //     "fi",
        //     "fr",
        //     "it",
        //     "nl",
        //     "pl",
        //     "ro",
        //     "pt",
        //     "ru",
        //     "tr",
        //     "ua"
        // ],
        renderTemplate: RENDER_TEMPLATE_ENUM.JSON_BY_HUMAN,
        show: false //!暂时不显示
    }),
    new Content({
        // num: 3,
        title: "20201220", //在版本列表显示的信息
        file: "20201220",
        version: "v3.20.1220", //目录名称，和/static/langPackzh对应
        desc: "comfortHome V3版本;之前杨伟胜用json的方案", //描述
        // supportLang: [
        //     "ch",
        //     "cs",
        //     "da",
        //     "de",
        //     "el",
        //     "en",
        //     "es",
        //     "fi",
        //     "fr",
        //     "hk",
        //     "hu",
        //     "id",
        //     "it",
        //     "jp",
        //     "kr",
        //     "nl",
        //     "pl",
        //     "pt",
        //     "ro",
        //     "ru",
        //     "sa",
        //     "se",
        //     "th",
        //     "tr",
        //     "tw",
        //     "ua",
        //     "vn"
        // ],
        renderTemplate: RENDER_TEMPLATE_ENUM.JSON_BY_HUMAN, //渲染的模板,模板的类型决定了数据源的扩展名
        show: process.env.OEM_APP === OEM_APP_ENUM.COMFORT_HOME //这里指定那些app（通过set OEM_APP="OMNIA_Smart"设置）可以显示这个版本
    }),
    new Content({
        // num: 4,
        title: "20210430",
        file: "20210430",
        version: "v4.21.0430",
        desc:
            "comfortHome V4版本;梁德锋第一次接手用html的方案(http://www.docpe.com/word/word-to-html.aspx)",
        // supportLang: [
        //     "ch",
        //     "da",
        //     "de",
        //     "el",
        //     "en",
        //     "es",
        //     "fr",
        //     "hu",
        //     "it",
        //     "nl",
        //     "pl",
        //     "pt",
        //     "ro",
        //     "ru",
        //     "tr",
        //     "ua"
        // ],
        renderTemplate: RENDER_TEMPLATE_ENUM.HTML_BY_DOCPE,
        show: process.env.OEM_APP === OEM_APP_ENUM.COMFORT_HOME
    }),
    new Content({
        title: "20220928",
        file: "20220928",
        version: "v1.22.0928",
        desc: `为大客户 Ferroli 定制App(OMNIA Smart)的隐私条款;
        为大客户 Lamborghini 定制App(IDOLA Smart)的隐私条款;梁德锋第二次接手用html的方案(mammoth.js)`,
        // supportLang: [
        //     "da",
        //     "de",
        //     "el",
        //     "en",
        //     "es",
        //     "fr",
        //     "hu",
        //     "it",
        //     "nl",
        //     "pl",
        //     "pt",
        //     "ro",
        //     "ru",
        //     "tr",
        //     "ua"
        // ],
        renderTemplate: RENDER_TEMPLATE_ENUM.HTML_BY_MAMMOTH,
        show:
            process.env.OEM_APP === OEM_APP_ENUM.OMNIA_SMART ||
            process.env.OEM_APP === OEM_APP_ENUM.IDOLA_SMART
    }),
    new Content({
        title: "20230320",
        file: "20230320",
        version: "v1.23.0320",
        desc: `为iLetComfort的隐私条款;`,
        // supportLang: ["en"],
        renderTemplate: RENDER_TEMPLATE_ENUM.HTML_BY_DOCPE,
        show: process.env.OEM_APP === OEM_APP_ENUM.IDOLA_I_LET_COMFORT
    }),
    new Content({
        title: "20230926",
        file: "20230926",
        version: "v2.23.0926",
        desc: `为iLetComfort的隐私条款;`,
        // supportLang: ["en"],
        renderTemplate: RENDER_TEMPLATE_ENUM.HTML_BY_DOCPE,
        show: process.env.OEM_APP === OEM_APP_ENUM.IDOLA_I_LET_COMFORT
    }),
    new Content({
        title: "20240119",
        file: "20240119",
        version: "v2.24.0119",
        desc: `为iLetComfort的隐私条款;`,
        // supportLang: ["en"],
        renderTemplate: RENDER_TEMPLATE_ENUM.HTML_BY_DOCPE,
        show: process.env.OEM_APP === OEM_APP_ENUM.IDOLA_I_LET_COMFORT
    }),
    new Content({
        title: "20240104",
        file: "20240104",
        version: "v1.0.0",
        desc: `为iLetComfort的隐私条款;`,
        // supportLang: ["en"],
        renderTemplate: RENDER_TEMPLATE_ENUM.HTML_BY_DOCPE,
        show: process.env.OEM_APP === OEM_APP_ENUM.FERROLI_I_LET_COMFORT
    }),
    new Content({
        title: "20241122",
        file: "20241122",
        version: "v4.21.1122",
        desc: `comfortHome 版本;`,
        // supportLang: ["en"],
        renderTemplate: RENDER_TEMPLATE_ENUM.HTML_BY_DOCPE,
        show: process.env.OEM_APP === OEM_APP_ENUM.COMFORT_HOME
    }),
    new Content({
        title: "20241126",
        file: "20241126",
        version: "v4.21.1126",
        desc: `comfortHome 版本;`,
        // supportLang: ["en"],
        renderTemplate: RENDER_TEMPLATE_ENUM.HTML_BY_DOCPE,
        show: process.env.OEM_APP === OEM_APP_ENUM.IDOLA_I_LET_COMFORT
    })
    // new Content({
    //     title: "20231018",
    //     file: "20231018",
    //     version: "v2.23.1018",
    //     desc: `为iLetComfort的注销协议;`,
    //     // supportLang: ["en"],
    //     renderTemplate: RENDER_TEMPLATE_ENUM.HTML_BY_DOCPE,
    //     show: process.env.OEM_APP === OEM_APP_ENUM.IDOLA_I_LET_COMFORT
    // }),
    // new Content({
    //     title: "20231019",
    //     file: "20231019",
    //     version: "v2.23.1019",
    //     desc: `为iLetComfort的用户服务协议;`,
    //     // supportLang: ["en"],
    //     renderTemplate: RENDER_TEMPLATE_ENUM.HTML_BY_DOCPE,
    //     show: process.env.OEM_APP === OEM_APP_ENUM.IDOLA_I_LET_COMFORT
    // })
];

// export const numMap = {};
export const titleMap = {};
export const versionMap = {};
export const versionList = [];
export const titleList = [];

list.filter(item => item.show).forEach(item => {
    // numMap[item.num] = item;
    titleMap[item.title] = item;
    versionMap[item.version] = item;

    versionList.push(item.version);
    titleList.push(item.title);
});



// WEBPACK FOOTER //
// ./src/utils/const/privacy.js